module.exports = __webpack_public_path__ + "static/Particulator2-7a2dd2c4c132c1b648f8a9feaa9c6e27.jpg";